var _g, _path, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#kl47v2862a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.088a2.451 2.451 0 0 1 4.902 0v2.82c0 .24-.016.48-.054.72a4.636 4.636 0 0 0-.035.262c-.027.277.006.638.193.88l-.448.432a6.96 6.96 0 0 1 3.787 6.206c0 .734-.112 1.441-.322 2.106l-.743 4.85H9.867v-.002c-3.73-.08-6.721-2.512-6.721-6.954 0-2.61 1.25-4.713 3.141-5.898l-.004-.004c.129-.09.28-.18.443-.278h.002c.536-.322 1.192-.716 1.537-1.358.3-.558.359-1.462.359-1.881h.001V4.088z",
    fill: "url(#lqc4le4wub)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.088a2.451 2.451 0 0 1 4.902 0v2.82c0 .24-.016.48-.054.72a4.636 4.636 0 0 0-.035.262c-.027.277.006.638.193.88l-.448.432a6.96 6.96 0 0 1 3.787 6.206c0 .734-.112 1.441-.322 2.106l-.743 4.85H9.867v-.002c-3.73-.08-6.721-2.512-6.721-6.954 0-2.61 1.25-4.713 3.141-5.898l-.004-.004c.129-.09.28-.18.443-.278h.002c.536-.322 1.192-.716 1.537-1.358.3-.558.359-1.462.359-1.881h.001V4.088z",
    fill: "url(#66duhrashc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.088a2.451 2.451 0 0 1 4.902 0v2.82c0 .24-.016.48-.054.72a4.636 4.636 0 0 0-.035.262c-.027.277.006.638.193.88l-.448.432a6.96 6.96 0 0 1 3.787 6.206c0 .734-.112 1.441-.322 2.106l-.743 4.85H9.867v-.002c-3.73-.08-6.721-2.512-6.721-6.954 0-2.61 1.25-4.713 3.141-5.898l-.004-.004c.129-.09.28-.18.443-.278h.002c.536-.322 1.192-.716 1.537-1.358.3-.558.359-1.462.359-1.881h.001V4.088z",
    fill: "url(#vyygungewd)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.088a2.451 2.451 0 0 1 4.902 0v2.82c0 .24-.016.48-.054.72a4.636 4.636 0 0 0-.035.262c-.027.277.006.638.193.88l-.448.432a6.96 6.96 0 0 1 3.787 6.206c0 .734-.112 1.441-.322 2.106l-.743 4.85H9.867v-.002c-3.73-.08-6.721-2.512-6.721-6.954 0-2.61 1.25-4.713 3.141-5.898l-.004-.004c.129-.09.28-.18.443-.278h.002c.536-.322 1.192-.716 1.537-1.358.3-.558.359-1.462.359-1.881h.001V4.088z",
    fill: "url(#gmo08jtpke)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.088a2.451 2.451 0 0 1 4.902 0v2.82c0 .24-.016.48-.054.72a4.636 4.636 0 0 0-.035.262c-.027.277.006.638.193.88l-.448.432a6.96 6.96 0 0 1 3.787 6.206c0 .734-.112 1.441-.322 2.106l-.743 4.85H9.867v-.002c-3.73-.08-6.721-2.512-6.721-6.954 0-2.61 1.25-4.713 3.141-5.898l-.004-.004c.129-.09.28-.18.443-.278h.002c.536-.322 1.192-.716 1.537-1.358.3-.558.359-1.462.359-1.881h.001V4.088z",
    fill: "url(#z5okyyvodf)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.088a2.451 2.451 0 0 1 4.902 0v2.82c0 .24-.016.48-.054.72a4.636 4.636 0 0 0-.035.262c-.027.277.006.638.193.88l-.448.432a6.96 6.96 0 0 1 3.787 6.206c0 .734-.112 1.441-.322 2.106l-.743 4.85H9.867v-.002c-3.73-.08-6.721-2.512-6.721-6.954 0-2.61 1.25-4.713 3.141-5.898l-.004-.004c.129-.09.28-.18.443-.278h.002c.536-.322 1.192-.716 1.537-1.358.3-.558.359-1.462.359-1.881h.001V4.088z",
    fill: "url(#8qqot09vfg)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hhdsbx39wh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.82 19.56c0-.35-.091-.68-.252-.961a2 2 0 0 0 1.084-1.796 2.02 2.02 0 0 0-.688-1.53 1.978 1.978 0 0 0 .659-1.485c0-.78-.44-1.452-1.074-1.763.301-.359.466-.813.464-1.282 0-1.073-.835-1.943-1.865-1.943h-2.064c-1.03 0-1.864.87-1.864 1.942a1.972 1.972 0 0 0 .667 1.491 1.975 1.975 0 0 0-.742 1.555 1.981 1.981 0 0 0 .673 1.498 2.017 2.017 0 0 0-.674 1.517c0 .546.21 1.04.552 1.4-.34.344-.552.825-.552 1.358 0 1.044.812 1.89 1.814 1.89h2.048c1.003 0 1.815-.846 1.815-1.89h-.001z",
    fill: "#E39F84"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vkoslt8jbi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.762 9.763c2.732 1.68 5.475.5 6.185 0l.63.81c-4.035 1.922-6.184.27-6.815-.81z",
    fill: "#E6A39A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 12.578a2.169 2.169 0 1 0 0-4.338h-2.403a2.169 2.169 0 1 0 0 4.338h2.403z",
    fill: "url(#uy5mqk456j)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 12.578a2.169 2.169 0 1 0 0-4.338h-2.403a2.169 2.169 0 1 0 0 4.338h2.403z",
    fill: "url(#1yb67odrkk)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 12.578a2.169 2.169 0 1 0 0-4.338h-2.403a2.169 2.169 0 1 0 0 4.338h2.403z",
    fill: "url(#yfocp6bg4l)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 12.578a2.169 2.169 0 1 0 0-4.338h-2.403a2.169 2.169 0 1 0 0 4.338h2.403z",
    fill: "url(#n13261y5tm)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 12.578a2.169 2.169 0 1 0 0-4.338h-2.403a2.169 2.169 0 1 0 0 4.338h2.403z",
    fill: "url(#30re8b7lrn)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.605 20.254v-.001a2.11 2.11 0 0 0-2.111-2.11h-2.383a2.11 2.11 0 0 0 0 4.222h2.383a2.11 2.11 0 0 0 2.11-2.111z",
    fill: "url(#mdrbfl7zro)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.605 20.254v-.001a2.11 2.11 0 0 0-2.111-2.11h-2.383a2.11 2.11 0 0 0 0 4.222h2.383a2.11 2.11 0 0 0 2.11-2.111z",
    fill: "url(#pje9yhgb0p)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.605 20.254v-.001a2.11 2.11 0 0 0-2.111-2.11h-2.383a2.11 2.11 0 0 0 0 4.222h2.383a2.11 2.11 0 0 0 2.11-2.111z",
    fill: "url(#kr43tlx6eq)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.605 20.254v-.001a2.11 2.11 0 0 0-2.111-2.11h-2.383a2.11 2.11 0 0 0 0 4.222h2.383a2.11 2.11 0 0 0 2.11-2.111z",
    fill: "url(#ixeh5er4wr)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.572 17.215v-.08a2.182 2.182 0 0 0-2.182-2.183h-3.208a2.182 2.182 0 0 0-2.183 2.182v.08c0 1.206.977 2.183 2.183 2.183h3.208a2.183 2.183 0 0 0 2.182-2.182z",
    fill: "url(#8w6ruzzvqs)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.572 17.215v-.08a2.182 2.182 0 0 0-2.182-2.183h-3.208a2.182 2.182 0 0 0-2.183 2.182v.08c0 1.206.977 2.183 2.183 2.183h3.208a2.183 2.183 0 0 0 2.182-2.182z",
    fill: "url(#cdr8cn3dwt)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.572 17.215v-.08a2.182 2.182 0 0 0-2.182-2.183h-3.208a2.182 2.182 0 0 0-2.183 2.182v.08c0 1.206.977 2.183 2.183 2.183h3.208a2.183 2.183 0 0 0 2.182-2.182z",
    fill: "url(#f6dtoaw90u)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.572 17.215v-.08a2.182 2.182 0 0 0-2.182-2.183h-3.208a2.182 2.182 0 0 0-2.183 2.182v.08c0 1.206.977 2.183 2.183 2.183h3.208a2.183 2.183 0 0 0 2.182-2.182z",
    fill: "url(#twtn053e0v)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.364 15.983a2.174 2.174 0 1 0 0-4.348h-3.19a2.174 2.174 0 1 0 0 4.348h3.19z",
    fill: "url(#n7eeqykdww)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.364 15.983a2.174 2.174 0 1 0 0-4.348h-3.19a2.174 2.174 0 1 0 0 4.348h3.19z",
    fill: "url(#bdslu1ewgx)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.364 15.983a2.174 2.174 0 1 0 0-4.348h-3.19a2.174 2.174 0 1 0 0 4.348h3.19z",
    fill: "url(#9fjdgea5ny)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.364 15.983a2.174 2.174 0 1 0 0-4.348h-3.19a2.174 2.174 0 1 0 0 4.348h3.19z",
    fill: "url(#beininrqqz)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "66duhrashc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.07033 -5.1328 2.12824 .02916 12.822 7.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8B80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "vyygungewd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(116.062 1.498 8.796) scale(5.43155 10.1078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEAEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAEA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gmo08jtpke",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.57406 -2.6017 2.9856 5.249 5.484 18.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z5okyyvodf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-3.48297 0 0 -7.47388 8.933 4.437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDAC4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "8qqot09vfg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -15.0171 9.70417 0 10.9 16.341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#BD7E96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD7E96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "yfocp6bg4l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.93564 0 0 1.50267 13.097 10.905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBC5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n13261y5tm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.48671 -.1296 .14175 6.00153 13.342 10.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#E8AE99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8AE99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "30re8b7lrn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -.69847 3.67378 0 15.877 11.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB887C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB887C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "pje9yhgb0p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 .80129 -3.30138 0 15.368 18.805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA384",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kr43tlx6eq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.08871 0 0 1.78677 13.213 20.982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ixeh5er4wr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.3759 -.12613 .13702 5.8401 13.229 20.255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#EBB398",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB398"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cdr8cn3dwt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 .84375 -3.78515 0 15.862 15.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA9F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9F82",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f6dtoaw90u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.01169 0 0 1.58049 13.45 17.596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "twtn053e0v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.16366 -.13279 .1325 6.15013 13.409 17.174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#EBB39A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB39A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bdslu1ewgx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.03794 1.59392 -8.69102 -.20685 16.918 11.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C88B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C88B90",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "9fjdgea5ny",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.00265 0 0 1.54591 13.443 14.222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5CB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "beininrqqz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.13595 -.12992 .12738 6.01564 13.401 13.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#EBB49B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB49B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lqc4le4wub",
    x1: 3.915,
    y1: 17.921,
    x2: 14.786,
    y2: 1.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB2A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uy5mqk456j",
    x1: 18.828,
    y1: 10.409,
    x2: 12.088,
    y2: 10.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7A195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BEB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1yb67odrkk",
    x1: 15.458,
    y1: 7.976,
    x2: 15.458,
    y2: 9.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7E93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mdrbfl7zro",
    x1: 17.924,
    y1: 19.151,
    x2: 12.595,
    y2: 20.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8w6ruzzvqs",
    x1: 18.791,
    y1: 16.013,
    x2: 12.791,
    y2: 18.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n7eeqykdww",
    x1: 18.142,
    y1: 11.937,
    x2: 12.228,
    y2: 14.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBBC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "kl47v2862a",
    x: 3.146,
    y: 1.637,
    width: 14.325,
    height: 20.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.921569 0 0 0 0 0.756863 0 0 0 0 0.65098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_36744_70521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hhdsbx39wh",
    x: 10.144,
    y: 6.8,
    width: 10.508,
    height: 16.652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_36744_70521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vkoslt8jbi",
    x: 5.262,
    y: 8.263,
    width: 9.815,
    height: 4.694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_36744_70521"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.1264cfd8655e5f4caa7c97c8674db049.svg";
export { ForwardRef as ReactComponent };